import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="patient-balance-override"
export default class extends Controller {
  static targets = [ "currentType", "changeToType", "hiddenInput", "visibleInput"]
  connect() {
  }

  changeType(event) {
    this.hiddenInputTarget.value = this.changeToTypeTarget.innerText
    const oldType = this.currentTypeTarget.innerText
    this.currentTypeTarget.innerText = this.changeToTypeTarget.innerText
    this.changeToTypeTarget.innerText = oldType
    this.visibleInputTarget.value = ""
  }
}
